
  /* eslint-disable */

// Global theme setter used by pages/components.
// Important: do not set data-theme if the value is already the same.
// This prevents MutationObserver -> setAttribute -> MutationObserver loops during route changes.
if (typeof window !== "undefined") {
  window.__flockrSetTheme = function(theme) {
    var next = theme === "dark" ? "dark" : "light";
    var html = document && document.documentElement;
    if (html && html.getAttribute("data-theme") !== next) {
      html.setAttribute("data-theme", next);
    }
    try { localStorage.setItem("flockr_theme", next); } catch (e) {}
  };

  // Default theme is LIGHT. If the user has never set a preference, persist 'light'
  // so every component's `localStorage.getItem('flockr_theme') || 'dark'` fallback resolves to 'light'.
  try {
    if (!localStorage.getItem("flockr_theme")) {
      localStorage.setItem("flockr_theme", "light");
    }
    window.__flockrSetTheme(localStorage.getItem("flockr_theme") || "light");
  } catch (e) {}
}

  import { createApp } from 'vue'
  import App from './App.vue'
  import router from "@/router";
  import vueHelmet from "vue-helmet/src/VueHelmet";
  import * as VueGoogleMaps from "vue3-google-map";
/*  import IdleVue from 'idle-vue'*/
  import IdleVue from "idle-vue";
  import BackButton from "@/components/BackButton.vue";


  // SEO switch (Alex 2026-07-22): now on history mode. If a visitor arrives via an
  // old WhatsApp/SMS-shared hash URL (flockr.africa/#/marketplace/listing/xxx),
  // convert it to the equivalent clean URL before the router boots. Prevents 404s
  // and preserves shared links.
  if (typeof window !== 'undefined' && window.location.hash && window.location.hash.indexOf('#/') === 0) {
    var cleanPath = window.location.hash.substring(1); // drop the '#'
    var target = window.location.origin + cleanPath + window.location.search;
    window.history.replaceState({}, '', target);
  }

  // Google Analytics 4 dynamic loader (Alex 2026-07-23).
  // Fetch ga4_measurement_id from the API's public settings; if present, inject
  // the gtag.js script + wire router page_view events. Setting is admin-editable
  // via /admin → Settings, so no redeploy is needed to swap properties.
  if (typeof window !== 'undefined' && !window.__flockrGa4Init) {
    window.__flockrGa4Init = true;
    fetch('https://api.craftcollect.africa/flockr/index.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: 'function=getPublicSettings'
    }).then(function(r){ return r.json(); }).then(function(json){
      var id = json && json.data && json.data.settings && json.data.settings.ga4_measurement_id;
      if (!id || String(id).indexOf('G-') !== 0) return;
      // Inject Google's official gtag loader
      var s = document.createElement('script');
      s.async = true;
      s.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(id);
      document.head.appendChild(s);
      window.dataLayer = window.dataLayer || [];
      window.gtag = function(){ window.dataLayer.push(arguments); };
      window.gtag('js', new Date());
      // send_page_view:false — we fire it ourselves on router.afterEach so SPA
      // route changes count as new page views.
      window.gtag('config', id, { send_page_view: false });
      window.__flockrGa4Id = id;
      // Fire an initial page_view for the landing route (router afterEach only
      // fires on subsequent navigations, not the very first paint).
      window.gtag('event', 'page_view', {
        page_title:    document.title,
        page_location: window.location.href,
        page_path:     window.location.pathname
      });
    }).catch(function(){ /* silent — analytics is best-effort */ });
  }

  const app = createApp(App);

  // Global $trackEvent — thin wrapper so components can emit conversion events
  // without touching gtag directly. No-ops when GA4 isn't loaded.
  app.config.globalProperties.$trackEvent = function(name, params) {
    if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
    try { window.gtag('event', name, params || {}); } catch(e){}
  };

  // Global $updateHead helper — any page component can override the SEO tags
  // for its route (e.g. ListingDetail sets the listing title as the page title).
  app.config.globalProperties.$updateHead = function(hint) {
    if (typeof document === 'undefined' || !hint) return;
    if (hint.title)       document.title = hint.title;
    var set = function(sel, name, val) {
      if (!val) return;
      var el = document.querySelector('meta[' + sel + '="' + name + '"]');
      if (!el) { el = document.createElement('meta'); el.setAttribute(sel, name); document.head.appendChild(el); }
      el.setAttribute('content', val);
    };
    set('name', 'description', hint.description);
    set('property', 'og:title', hint.title);
    set('property', 'og:description', hint.description);
    set('property', 'og:image', hint.image);
    set('property', 'og:url', window.location.href);
    set('name', 'twitter:title', hint.title);
    set('name', 'twitter:description', hint.description);
    set('name', 'twitter:image', hint.image);
    // Inject JSON-LD (rich snippets) if provided
    if (hint.jsonLd) {
      var prior = document.querySelector('script[data-jsonld="1"]');
      if (prior) prior.remove();
      var s = document.createElement('script');
      s.type = 'application/ld+json';
      s.setAttribute('data-jsonld', '1');
      s.textContent = JSON.stringify(hint.jsonLd);
      document.head.appendChild(s);
    }
  };

  app.component("BackButton", BackButton);

  app.use(VueGoogleMaps,{ load: {key: "AIzaSyAGPbYfcYqdbSBeXdIpH5iWrznfU886Qk8"}})
  app.use(router)
  app.use(vueHelmet)

/*  app.use(IdleVue, {
    eventEmitter: app,
    idleTime: 20000,
    startEventName: "load",
    resetEvents: ["click", "mousemove", "keydown", "touchstart"],
    idleTimeoutCallback: () => {
      app.$router.push("/");
    },
  });*/
  app.mount("#app");




